import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es6.array.map.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import DecadePanel from '../decade/DecadePanel';
import DateInput from '../date/DateInput';
import moment from 'moment';
var ROW = 4;
var COL = 3;

function goYear(direction) {
  var value = this.state.value.clone();
  value.add(direction, 'year');
  this.setState({
    value: value
  });
}

function chooseYear(year) {
  var value = this.state.value.clone();
  value.year(year);
  value.month(this.state.value.month());
  this.props.onSelect(value);
}

var YearPanel = /*#__PURE__*/function (_React$Component) {
  _inherits(YearPanel, _React$Component);

  var _super = _createSuper(YearPanel);

  function YearPanel(_props) {
    var _this;

    _classCallCheck(this, YearPanel);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "yearSelect", function (value) {
      var props = _this.props;
      var onSelect = props.onSelect,
          format = props.format,
          disabledYear = props.disabledYear;
      var isDisabled = disabledYear && disabledYear(value);
      if (isDisabled) return;
      onSelect && onSelect(value, value ? value.format(format) : '');
    });

    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (value) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          format = _this$props.format;

      _this.setState({
        value: value ? value : moment()
      });

      onChange && onChange(value, value ? value.format(format) : '');
    });

    _defineProperty(_assertThisInitialized(_this), "onClear", function () {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          format = _this$props2.format,
          onClear = _this$props2.onClear;

      _this.setState({
        value: moment()
      });

      onChange && onChange('', '');
      onClear && onClear('', '');
    });

    _this.prefixCls = "".concat(_props.rootPrefixCls, "-year-panel");
    _this.state = {
      value: _props.value || _props.defaultValue || moment()
    };
    _this.nextDecade = goYear.bind(_assertThisInitialized(_this), 10);
    _this.previousDecade = goYear.bind(_assertThisInitialized(_this), -10);
    ['showDecadePanel', 'onDecadePanelSelect'].forEach(function (method) {
      _this[method] = _this[method].bind(_assertThisInitialized(_this));
    });
    return _this;
  }

  _createClass(YearPanel, [{
    key: "onDecadePanelSelect",
    value: function onDecadePanelSelect(current) {
      this.setState({
        value: current,
        showDecadePanel: 0
      });
    } //add by supernever

  }, {
    key: "years",
    value: function years() {
      var value = this.state.value;
      var currentYear = value.year();
      var startYear = parseInt(currentYear / 10, 10) * 10;
      var previousYear = startYear - 1;
      var years = [];
      var index = 0;

      for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
        years[rowIndex] = [];

        for (var colIndex = 0; colIndex < COL; colIndex++) {
          var year = previousYear + index;
          var content = String(year);
          years[rowIndex][colIndex] = {
            content: content,
            year: year,
            title: content
          };
          index++;
        }
      }

      return years;
    }
  }, {
    key: "showDecadePanel",
    value: function showDecadePanel() {
      this.setState({
        showDecadePanel: 1
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;
      var value = this.state.value;
      var locale = props.locale;
      var years = this.years();
      var currentYear = value.year();
      var startYear = parseInt(currentYear / 10, 10) * 10;
      var endYear = startYear + 9;
      var prefixCls = this.prefixCls;
      var yeasEls = years.map(function (row, index) {
        var tds = row.map(function (yearData) {
          var _classNameMap;

          var disabled = props.disabledYear && props.disabledYear(moment(yearData.title));
          var classNameMap = (_classNameMap = {}, _defineProperty(_classNameMap, "".concat(prefixCls, "-cell"), 1), _defineProperty(_classNameMap, "".concat(prefixCls, "-selected-cell"), yearData.year === currentYear), _defineProperty(_classNameMap, "".concat(prefixCls, "-disabled-cell"), disabled), _classNameMap);
          var clickHandler; // if (yearData.year < startYear) {
          //   clickHandler = this.previousDecade;
          // } else if (yearData.year > endYear) {
          //   clickHandler = this.nextDecade;
          // } else {

          clickHandler = chooseYear.bind(_this2, yearData.year); // }

          return /*#__PURE__*/React.createElement("td", {
            role: "gridcell",
            title: yearData.title,
            key: yearData.content,
            onClick: props.disabledYear && props.disabledYear(moment(yearData.title)) ? undefined : clickHandler,
            className: classnames(classNameMap)
          }, /*#__PURE__*/React.createElement("a", {
            className: "".concat(prefixCls, "-year")
          }, yearData.content));
        });
        return /*#__PURE__*/React.createElement("tr", {
          key: index,
          role: "row"
        }, tds);
      });
      var decadePanel;

      if (this.state.showDecadePanel) {
        decadePanel = /*#__PURE__*/React.createElement(DecadePanel, {
          locale: locale,
          value: value,
          rootPrefixCls: props.rootPrefixCls,
          onSelect: this.onDecadePanelSelect
        });
      }

      var showDateInput = props.showDateInput,
          rootPrefixCls = props.rootPrefixCls,
          format = props.format,
          validatorFunc = props.validatorFunc,
          inputReadOnly = props.inputReadOnly;
      return (
        /*#__PURE__*/
        //注意：缺失rootPrefixCls会导致年份面板不能点选，因为style会生成：pointer-event:none
        React.createElement("div", {
          className: "".concat(props.rootPrefixCls, " ").concat(this.prefixCls)
        }, /*#__PURE__*/React.createElement("div", null, showDateInput ? /*#__PURE__*/React.createElement(DateInput, {
          value: value,
          prefixCls: this.props.rootPrefixCls,
          showClear: true,
          locale: locale,
          format: format,
          inputReadOnly: inputReadOnly,
          onChange: this.onInputChange,
          selectedValue: value,
          onClear: this.onClear,
          onSelect: this.yearSelect,
          validatorFunc: validatorFunc
        }) : '', /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-header")
        }, /*#__PURE__*/React.createElement("a", {
          className: "".concat(prefixCls, "-prev-decade-btn"),
          role: "button",
          onClick: this.previousDecade,
          title: locale.previousDecade
        }), /*#__PURE__*/React.createElement("a", {
          className: "".concat(prefixCls, "-decade-select"),
          role: "button",
          onClick: this.showDecadePanel,
          title: locale.decadeSelect
        }, /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-decade-select-content")
        }, startYear, "-", endYear), /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-decade-select-arrow")
        }, "x")), /*#__PURE__*/React.createElement("a", {
          className: "".concat(prefixCls, "-next-decade-btn"),
          role: "button",
          onClick: this.nextDecade,
          title: locale.nextDecade
        })), /*#__PURE__*/React.createElement("div", {
          className: "".concat(prefixCls, "-body")
        }, /*#__PURE__*/React.createElement("table", {
          className: "".concat(prefixCls, "-table"),
          cellSpacing: "0",
          role: "grid"
        }, /*#__PURE__*/React.createElement("tbody", {
          className: "".concat(prefixCls, "-tbody")
        }, yeasEls)))), decadePanel)
      );
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var value = nextProps.value,
          defaultValue = nextProps.defaultValue;
      var newState = {};
      newState.value = "showDecadePanel" in state ? state.value : value || defaultValue || moment();
      return newState;
    }
  }]);

  return YearPanel;
}(React.Component);

export { YearPanel as default };
YearPanel.propTypes = {
  rootPrefixCls: PropTypes.string,
  value: PropTypes.object,
  locale: PropTypes.object,
  defaultValue: PropTypes.object,
  disabledYear: PropTypes.bool
};
YearPanel.defaultProps = {
  onSelect: function onSelect() {},
  format: 'YYYY',
  showDateInput: false
};


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/rc-calendar/year/YearPanel.js